export const en = {
  landing: {
    title: 'Log Into your Account',
    signin: 'Sign in with Google',
  },
  lease: {
    back: 'Back',
    viewLease: 'View Lease',
    applicant: {
      addNewTab: '+ Add New Applicant',
      addNewTitle: 'Add New Applicant',
      name: 'Name',
      email: 'Email',
      householdStatus: 'Household Status',
      invalidEmail: 'Please enter a valid email address',
      addButton: 'Add Applicant',
      successAdded: 'Applicant added successfully.',
      errorAdd: 'Failed to add applicant',
    },
    resident: {
      title: 'Resident',
      name: 'Name:',
      email: 'Email:',
      phone: 'Phone Number:',
      leasingFrom: 'Leasing From:',
      password: 'Password:',
      loginAsUser: 'Login as user',
      loginAsOpening: 'Opening…',
      loginAsSuccess: 'Resident portal opened in a new tab (read-only, 15 min; payments disabled).',
      loginAsFailed: 'Could not open login-as session.',
      lastLogin: 'Last Login',
      registered: 'Registered in TenantPort',
      editingEmail: 'This new email will automatically update in Resman.',
      outsync: 'Data is currently out of sync with Resman',
      ssnVerified: 'SSN Verified in TenantPort',
      credbuild: 'Opt-Out CredBuild',
      removeSSN: 'Remove SSN Requirement',
      resetPassword: 'Reset Password',
      inviteSent: 'Invite Sent:',
      invitationSent: 'Invitation Sent',
      inviteResent: 'Invitation Resent!',
      resendInvitation: 'Resend Invitation',
      sendInvitation: 'Send Invitation',
      inviteLink: 'Invite Link:',
      copyInviteLink: 'Copy Invite Link',
      linkCopied: 'Invite link copied to clipboard',
      linkCopyFailed: 'Could not copy link',
      inviteLinkEmailHint:
        'Only needed if the applicant did not receive the invite email. Email this link to them — do not text it; it is long and often breaks or gets blocked in text messages.',
      residentInfo: 'To edit details of the resident, please update in Resman, then press Sync to show changes',
      sync: 'Sync w/Resman',
      applicationStatus: 'Application Submission Status',
      resumeLink: 'Resume application:',
      copyResumeLink: 'Copy resume link',
      resumeLinkCopied: 'Resume link copied.',
      resumeLinkCopyFailed: 'Could not copy resume link.',
      resumeLinkHint: 'Send this so the applicant continues where they left off. Prefer email — long links often break or get blocked in text messages.',
      birthDate: 'Birth Date:',
      status: 'Status:',
      loginOnOtherLease: 'This login is currently connected to {{name}}, not the person on this lease.',
      accountsForEmail: 'Accounts for this email',
      showAccounts: 'Show accounts',
      hideAccounts: 'Hide accounts',
      associationsTitle: 'Email associations',
      associationsSubtitle: 'Logins and ResMan people for {{email}}',
      associationsLoadFailed: 'Could not load email associations.',
      associationsEmpty: 'No other accounts found for this email.',
      associationsLogin: 'Login',
      associationsPaymentSummary: '{{count}} saved payment method(s) · Autopay {{autopay}}',
      associationsAutopayOn: 'on',
      associationsAutopayOff: 'off',
      associationsCredBuildWarning: 'Open CredBuild account on the linked person — it will stay on that lease.',
      associationsNoPerson: 'Login has no linked person.',
      associationsOtherPersons: 'Other ResMan people (no login)',
      associationsThisResident: 'this resident',
      associationsNoLeases: 'No leases on this person',
      associationsOpenCredBuild: 'open CredBuild',
      connectLogin: 'Connect login',
      connectLoginToThisResident: 'Connect this login to this resident',
      rebindTitle: 'Connect login to this resident?',
      rebindBody: 'Reconnect {{email}} from {{from}} to {{to}}. Auth0 stays the same; the resident keeps their password.',
      rebindUnknownPerson: 'another person',
      rebindPaymentWarning: '{{count}} saved payment method(s) will be removed and autopay will be turned off. The resident must add a payment method again.',
      rebindCredBuildWarning: 'An open CredBuild account on the previous lease will stay there and will not move with this login.',
      rebindMoveLoginRequired: 'This login is still on an active lease elsewhere. Reason must start with MOVE_LOGIN (super-admin only).',
      rebindReasonLabel: 'Reason',
      rebindReasonHint: 'Required for the audit trail (3–500 characters).',
      rebindConfirm: 'Connect login',
      rebindSuccess: 'Login connected to this resident.',
      rebindFailed: 'Could not connect login to this resident.',
      moveOutDate: 'Move out date:',
    },
    payment: {
      title: 'Payment Info',
      empty: 'There are no payment methods',
      autoPay: 'Auto Pay',
      autoPayDate: 'Auto Pay Date',
      on: 'On',
      off: 'Off',
      status: 'Online Payment Status',
      enabled: 'Enabled',
      disabled: 'Disabled',
      certifiedFunds: 'Certified Funds Only',
      description: 'Online Payments have been disabled due to failed attempts. Please reach out to your RM to change this status.',
    },
    transaction: {
      title1: 'Resman Ledger',
      title2: 'Transactions',
      empty: 'There are no transactions',
      viewAll: 'View All',
    },
    request: {
      title: 'Requests',
      empty: 'There are no work orders',
    },
    password: {
      resetTitle: 'Are You Sure You Want to Reset Their password?',
      resetDescription: 'They will receive a email asking them to create a new password.',
      resetPassword: 'Reset Password',
      changeTitle: "Change the Tenant's Password",
      changeDescription: 'This allows you to change the password on the tenants behalf. Please make sure to notify the tenant on the new password',
      changePassword: 'Change Password',
      credbuildTitle: 'Are You Sure You Want to Disable and End the Tenants CredBuild Subscription?',
      credbuildDescription: 'This will take affect on the next months bill cycle.',
    },
    success: {
      invite: 'Invite was resent to {{ property }}',
    },
  },
  logout: {
    title: 'Log Out',
    description: 'Are you sure you want to log out?',
    return: 'Return',
  },
  pagination: {
    rowsPerPage: 'Rows per page',
  },
  properties: {
    title: 'Search for Residents',
    unitNumber: 'Unit Number',
    current: 'Current',
    renewed: 'Renewed',
    pending: 'Pending',
    pendingTransfer: 'Pending Transfer',
    former: 'Former',
    evicted: 'Evicted',
    underEviction: 'Under Eviction',
    search: 'Select a unit number to start your search',
    residentName: 'Resident(s) Name',
    status: 'Lease Status',
    ssnVerified: 'SSN Verified in TP',
    registered: 'Registered in TP',
    startDate: 'Lease Start Date',
    endDate: 'Lease End Date',
    empty: 'There are no residents based off of that search criteria.',
    emptySearchWithUnit: 'There are no residents for Unit {{ unit }} based off of that search criteria.',
  },
  applicationDetail: {
    title: 'Application',
    backToReports: 'Back to Applicants',
    forbidden: 'You do not have access to this application.',
    notFound: 'Application not found.',
    loadError: 'Could not load this application.',
    hasLease: 'This application has a lease record.',
    viewLease: 'View lease',
    submissionError: 'Submission error',
    paymentSucceeded: 'Payment succeeded',
    paymentSucceededGuidance:
      'The payment went through. Do not ask the applicant to submit another payment — contact TenantPort support to resolve the submission error.',
    submissionErrorGuidance: 'Contact TenantPort support to resolve the submission error.',
    applicant: 'Applicant',
    email: 'Email',
    mobilePhone: 'Mobile Phone',
    householdStatus: 'Household Status (role)',
    property: 'Property',
    unit: 'Unit',
    moveInDate: 'Move-in Date',
    leaseTerm: 'Lease Term',
    rent: 'Rent',
    selectionTitle: 'Application selection',
    selectionDescription: 'Pick an available unit and priced lease term, then save. That queues lease creation for this application.',
    selectionLeaseQueued: 'Selection saved. Lease creation was queued.',
    creatingLease: 'Selection saved. Creating the lease… this page will update when it finishes.',
    selectUnit: 'Select unit',
    selectLeaseTerm: 'Select lease term',
    selectLeaseTermToContinue: 'Select a lease term to continue.',
    unitAvailableFrom: 'Unit available from {{date}}',
    loadingAvailability: 'Loading available units and lease terms…',
    availabilityLoadError: 'Could not load available units for this move-in date.',
    noUnitsForDate: 'No units are available for the selected move-in date. Please try a different date.',
    unitNotAvailable: 'Unit {{unit}} is not currently available. It may be leased or the move-in date is outside its pricing window.',
    unitNoTerms: 'This unit is not available for the selected move-in date. Please try a different date.',
    selectionSaved: 'Application selection saved.',
    selectionSavedAndRetried: 'Selection saved. Finalization was queued again.',
    selectionSaveFailed: 'Could not save application selection.',
    selectionRetryNotice: 'This paid application failed finalization. Saving a valid selection will reopen finalization and queue another attempt.',
    status: 'Application status',
    submissionStatus: 'Submission Status',
    paymentStatus: 'Payment Status',
    finalizationState: 'Finalization State',
    idVerification: 'ID Verification',
    idvFailedLabel: 'Failed',
    viewInPlaid: 'View in Plaid',
    viewInPlaidMany: 'View in Plaid ({{count}} sessions)',
    leaseRecord: 'Lease Record',
    applicationDate: 'Application Date',
    lastUpdated: 'Last Updated',
    roster: 'Household roster (as submitted)',
    rosterName: 'Name',
    rosterRole: 'Role / Relationship',
    rosterEmail: 'Email',
    rosterOwnRecord: 'Own record?',
    rosterThisApp: 'This application',
    rosterNotYet: 'Not yet',
    minorSuffix: '(minor)',
    rosterNote: 'From the application itself — separate records and logins are not created until the lease finalizes.',
    submittedApplication: 'Submitted Application',
    submittedApplicationSubtitle: 'Read-only view of everything this applicant entered, exactly as submitted.',
    submittedApplicationEmpty:
      "This applicant hasn't entered any application details on this record. It may be a duplicate — check their other applications below.",
    otherApplications: "Applicant's other applications",
    otherAppsProperty: 'Property',
    otherAppsStatus: 'Status',
    otherAppsData: 'Has data',
    otherAppsLease: 'Lease',
    otherAppsView: 'View',
    otherAppsYes: 'Yes',
    otherAppsNote: 'Same applicant, other application records. A completed or leased row here usually means this one is a duplicate.',
  },
  common: {
    cancel: 'Cancel',
    save: 'Save',
    reset: 'Reset',
    change: 'Change',
    close: 'Close',
    success: 'Success',
    pending: 'Pending',
    skipped: 'Skipped',
    failed: 'Failed',
    notRequired: 'Not Required',
    default: 'Default',
    disable: 'Disable',
  },
};
